import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBellCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBellCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M3.81319 9.35647C4.26146 5.17264 7.79219 2 12 2C16.2077 2 19.7385 5.17264 20.1867 9.35648L21 17.5H3L3.81319 9.35647ZM15.9142 9L14.5 7.58579L11 11.0858L9.5 9.58579L8.08579 11L11 13.9142L15.9142 9Z" fill="currentColor"/><Path d="M12 22C9.94965 22 8.18757 20.7659 7.41601 19H16.5839C15.8124 20.7659 14.0503 22 12 22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBellCheck;
